<template>
<div class="app calendar-page">
    <v-card flat class="calendar-top-card">
        <v-layout row wrap>
            <v-flex xs12 sm12>
                <v-toolbar size="120px" dark class="calendar-page-toolbar">
                    <div class="calendar-brand">
                        <div class="calendar-brand-icon">
                            <v-icon color="white">date_range</v-icon>
                        </div>
                        <div class="calendar-brand-copy">
                            <div class="calendar-brand-title">{{ $t('Calendar') }}</div>
                            <div class="calendar-brand-accent"></div>
                        </div>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="calendar-toolbar-mark">
                        <v-icon color="white">event_available</v-icon>
                    </div>
                </v-toolbar>
            </v-flex>
        </v-layout>
    </v-card>

    <div class='demo-app'>
        <div class='demo-app-main calendar-surface'>
            <FullCalendar class='demo-app-calendar' ref="fullCalendar" :options='calendarOptions'>
                <template v-slot:eventContent='arg'>
                    <span class="pa-1">
                        <v-icon color="blue" v-if="arg.event.extendedProps.Provider == 'ticket'">flight</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 1">hotel</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 2">rv_hookup</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 3">restaurant</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 4">local_see</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 5">departure_board</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 6">emoji_people</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 7">house</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 8">flight_takeoff</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 9">directions_boat</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 10">category</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 11">style</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 12">tour</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 13">meeting_room&</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 14">verified_user</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 15">directions_boat</v-icon>
                        <v-icon color="blue" v-if="arg.event.extendedProps.SalesType == 16">golf_course</v-icon>
                    </span>
                    <span v-if="arg.event.backgroundColor == 'purple'" class="purple darken-2 white--text pa-1">{{ arg.event.title }}</span>
                    <span v-if="arg.event.backgroundColor == 'green'" class="green darken-2 white--text pa-1 ">{{ arg.event.title }}</span>
                </template>
            </FullCalendar>
        </div>
    </div>

    <v-dialog v-model="coperdetay" v-if="coperdetay" persistent="" max-width="1240px" content-class="modern-coper-dialog">
        <v-card class="coper-popup-card">
            <div class="coper-popup-header">
                <div class="coper-popup-header-icon">
                    <v-icon color="white">event_note</v-icon>
                </div>
                <div class="coper-popup-heading">
                    <div class="coper-popup-title">{{ $t('Coper-List') }}</div>
                    <div class="coper-popup-header-line"></div>
                </div>
                <v-spacer></v-spacer>
                <v-btn icon flat class="coper-popup-close" @click.native="coperdetay=false">
                    <v-icon color="white">close</v-icon>
                </v-btn>
            </div>
            <v-card-text class="coper-popup-body">
                <v-layout row wrap="">
                    <v-flex v-if="coperOtel" xs12 sm12 md12>
                        <v-data-table class="modern-coper-table" :headers="headercoperOtel" :rows-per-page-items="[5,20,100]" :items="coperOtelList">
                            <template slot="items" slot-scope="props">
                                <tr item class="coper-table-row">
                                    <td class="text-xs-left">{{ props.item.MusteriAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                    <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.Konum }}</td>
                                    <td class="text-xs-left">{{ props.item.OdaTipi}}</td>
                                    <td class="text-xs-left">
                                        <span class="coper-pnr-badge">{{ props.item.PNR || '-' }}</span>
                                    </td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="gitcoper(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex v-if="coperArac" xs12 sm12 md12>
                        <v-data-table class="modern-coper-table" :headers="headercoperArac" :rows-per-page-items="[5,20,100]" :items="coperAracList">
                            <template slot="items" slot-scope="props">
                                <tr item class="coper-table-row">
                                    <td class="text-xs-left">{{ props.item.MusteriAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                    <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.AracTip}}</td>
                                    <td class="text-xs-left">{{ props.item.Nereden }}</td>
                                    <td class="text-xs-left">{{ props.item.Nereye}}</td>
                                    <td class="text-xs-left">
                                        <span class="coper-pnr-badge">{{ props.item.PNR || '-' }}</span>
                                    </td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="gitcoper(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex v-if="coperCharter" xs12 sm12 md12>
  <v-data-table
    class="modern-coper-table"
    :headers="headercoperCharter"
    :rows-per-page-items="[5,20,100]"
    :items="coperCharterList"
  >
    <template slot="items" slot-scope="props">
      <tr item class="coper-table-row">
        <td class="text-xs-left">
          {{ props.item.MusteriAdi }}
        </td>

        <td class="text-xs-left">
          {{ props.item.SaticiAdi }}
        </td>

        <td class="text-xs-left">
          {{ props.item.Nereden }}
        </td>

        <td class="text-xs-left">
          {{ props.item.Nereye }}
        </td>

        <td class="text-xs-left">
          {{ props.item.UcusSaati }}
        </td>

        <td class="text-xs-left">
          {{ props.item.Tarih | dateformat }}
        </td>

        <td class="text-xs-left">
          <span v-if="props.item.OpsiyonluMusteri">
            {{ props.item.OpsiyonTarihi | dateformat }}
          </span>
          <span v-else>-</span>
        </td>

        <td class="text-xs-left">
          {{ props.item.OpsiyonluMusteri ? props.item.OpsiyonSaati : '-' }}
        </td>

        <td class="text-xs-left">
                                        <span class="coper-pnr-badge">{{ props.item.PNR || '-' }}</span>
                                    </td>
                                    <td class="justify-end align-center layout pr-2">
          <v-btn
            icon
            small
            slot="activator"
            flat
            @click="gitcoper(props.item)"
          >
            <v-icon color="info">search</v-icon>
          </v-btn>
        </td>
      </tr>
    </template>
  </v-data-table>
</v-flex>
                    <v-flex v-if="coperAll" xs12 sm12 md12>
                        <v-data-table class="modern-coper-table" :headers="headercoperAll" :rows-per-page-items="[5,20,100]" :items="coperAllList">
                            <template slot="items" slot-scope="props">
                                <tr item class="coper-table-row">
                                    <td class="text-xs-left">{{ props.item.MusteriAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                    <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                                    <td class="text-xs-left">
                                        <span class="coper-pnr-badge">{{ props.item.PNR || '-' }}</span>
                                    </td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="gitcoper(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex v-if="coperDiger" xs12 sm12 md12>
                        <v-data-table class="modern-coper-table" :headers="headercoperDiger" :rows-per-page-items="[5,20,100]" :items="coperDigerList">
                            <template slot="items" slot-scope="props">
                                <tr item class="coper-table-row">
                                    <td class="text-xs-left">{{ props.item.MusteriAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                    <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.Aktivite}}</td>
                                    <td class="text-xs-left">
                                        <span class="coper-pnr-badge">{{ props.item.PNR || '-' }}</span>
                                    </td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="gitcoper(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex v-if="coperRentCikis" xs12 sm12 md12>
                        <v-data-table class="modern-coper-table" :headers="headercoperRentCikis" :rows-per-page-items="[5,20,100]" :items="coperRentCikisList">
                            <template slot="items" slot-scope="props">
                                <tr item class="coper-table-row">
                                    <td class="text-xs-left">{{ props.item.MusteriAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                    <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.TeslimSaati}}</td>
                                    <td class="text-xs-left">{{ props.item.TeslimYeri}}</td>
                                    <td class="text-xs-left">{{ props.item.AracTipi}}</td>
                                    <td class="text-xs-left">{{ props.item.Arac}}</td>
                                    <td class="text-xs-left">
                                        <span class="coper-pnr-badge">{{ props.item.PNR || '-' }}</span>
                                    </td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="gitcoper(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex v-if="coperRentGiris" xs12 sm12 md12>
                        <v-data-table class="modern-coper-table" :headers="headercoperRentGiris" :rows-per-page-items="[5,20,100]" :items="coperRentGirisList">
                            <template slot="items" slot-scope="props">
                                <tr item class="coper-table-row">
                                    <td class="text-xs-left">{{ props.item.MusteriAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                    <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.AlinisSaati}}</td>
                                    <td class="text-xs-left">{{ props.item.AlinisYeri}}</td>
                                    <td class="text-xs-left">{{ props.item.AracTipi}}</td>
                                    <td class="text-xs-left">{{ props.item.Arac}}</td>
                                    <td class="text-xs-left">
                                        <span class="coper-pnr-badge">{{ props.item.PNR || '-' }}</span>
                                    </td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="gitcoper(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex v-if="coperTur" xs12 sm12 md12>
                        <v-data-table class="modern-coper-table" :headers="headercoperTur" :rows-per-page-items="[5,20,100]" :items="coperTurList">
                            <template slot="items" slot-scope="props">
                                <tr item class="coper-table-row">
                                    <td class="text-xs-left">{{ props.item.MusteriAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                    <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.Saat}}</td>
                                    <td class="text-xs-left">{{ props.item.BulusmaYeri}}</td>
                                    <td class="text-xs-left">
                                        <span class="coper-pnr-badge">{{ props.item.PNR || '-' }}</span>
                                    </td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="gitcoper(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex v-if="coperGemi" xs12 sm12 md12>
                        <v-data-table class="modern-coper-table" :headers="headercoperGemi" :rows-per-page-items="[5,20,100]" :items="coperGemiList">
                            <template slot="items" slot-scope="props">
                                <tr item class="coper-table-row">
                                    <td class="text-xs-left">{{ props.item.MusteriAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                    <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.Konum }}</td>
                                    <td class="text-xs-left">{{ props.item.OdaTipi}}</td>
                                    <td class="text-xs-left">
                                        <span class="coper-pnr-badge">{{ props.item.PNR || '-' }}</span>
                                    </td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="gitcoper(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex v-if="coperSigorta" xs12 sm12 md12>
                        <v-data-table class="modern-coper-table" :headers="headercoperSigorta" :rows-per-page-items="[5,20,100]" :items="coperSigortaList">
                            <template slot="items" slot-scope="props">
                                <tr item class="coper-table-row">
                                    <td class="text-xs-left">{{ props.item.MusteriAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                    <td class="text-xs-left">{{ props.item.BasTarih | dateformat }}</td>
                                    <td class="text-xs-left">{{ props.item.BitTarih | dateformat }}</td>
                                    <td class="text-xs-left">
                                        <span class="coper-pnr-badge">{{ props.item.PNR || '-' }}</span>
                                    </td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="gitcoper(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex v-if="coperVizeGiris" xs12 sm12 md12>
                        <v-data-table class="modern-coper-table" :headers="headercoperVizeGiris" :rows-per-page-items="[5,20,100]" :items="coperVizeGirisList">
                            <template slot="items" slot-scope="props">
                                <tr item class="coper-table-row">
                                    <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                    <td class="text-xs-left">{{ props.item.MusteriAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.VizeTip }}</td>
                                    <td class="text-xs-left">
                                        <span class="coper-pnr-badge">{{ props.item.PNR || '-' }}</span>
                                    </td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="gitcoper(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex v-if="coperVizeCikis" xs12 sm12 md12>
                        <v-data-table class="modern-coper-table" :headers="headercoperVizeCikis" :rows-per-page-items="[5,20,100]" :items="coperVizeCikisList">
                            <template slot="items" slot-scope="props">
                                <tr item class="coper-table-row">
                                    <td class="text-xs-left">{{ props.item.SaticiAdi}}</td>
                                    <td class="text-xs-left">{{ props.item.MusteriAdi }}</td>
                                    <td class="text-xs-left">{{ props.item.VizeTip}}</td>
                                    <td class="text-xs-left">
                                        <span class="coper-pnr-badge">{{ props.item.PNR || '-' }}</span>
                                    </td>
                                    <td class="justify-end align-center layout pr-2">
                                        <v-btn icon small slot="activator" flat @click="gitcoper(props.item)">
                                            <v-icon color="info">search</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-flex>

                </v-layout>
            </v-card-text>
            <v-card-actions class="coper-popup-footer">
                <v-spacer></v-spacer>
                <v-btn flat class="coper-popup-cancel-btn" @click.native="coperdetay=false">
                    <v-icon left small>close</v-icon>
                    {{$t("cancel_button")}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="ticketdetay" v-if="ticketdetay" persistent="" max-width="1180px" content-class="modern-flight-dialog">
        <v-card class="flight-popup-card">
            <div class="flight-popup-header">
                <div class="flight-popup-header-icon">
                    <v-icon color="white">flight_takeoff</v-icon>
                </div>
                <div class="flight-popup-heading">
                    <div class="flight-popup-title">{{ $t('Flight-List') }}</div>
                    <div class="flight-popup-header-line"></div>
                </div>
                <v-spacer></v-spacer>
                <v-btn icon flat class="flight-popup-close" @click.native="ticketdetay=false">
                    <v-icon color="white">close</v-icon>
                </v-btn>
            </div>
            <v-card-text class="flight-popup-body">
                <v-layout row wrap="">
                    <v-flex xs12 sm12 md12>
                        <div class="flight-table-shell">
                            <v-data-table class="modern-flight-table" :headers="headerticket" :rows-per-page-items="[5,20,100]" :items="ticketList">
                                <template slot="items" slot-scope="props">
                                    <tr item class="flight-table-row">
                                        <td class="text-xs-left">
                                            <span class="airline-badge">{{props.item.HavayoluKodu}}</span>
                                        </td>
                                        <td class="text-xs-left">
                                            <span class="route-code">{{ props.item.KalkisParkur }}</span>
                                        </td>
                                        <td class="text-xs-left">
                                            <span class="route-code">{{ props.item.VarisParkur }}</span>
                                        </td>
                                        <td class="text-xs-left flight-time-cell">{{ props.item.UcusSaat }}</td>
                                        <td class="text-xs-left flight-date-cell">{{ props.item.UcusTarihi | dateformat }}</td>
                                        <td class="text-xs-left passenger-cell">{{ props.item.YolcuAdi }}</td>
                                        <td class="text-xs-left">
                                            <span class="pnr-badge">{{ props.item.PnrNo }}</span>
                                        </td>
                                        <td class="justify-end align-center layout pr-2">
                                            <v-btn icon small slot="activator" flat class="flight-detail-btn" @click="git(props.item)">
                                                <v-icon>search</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </div>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions class="flight-popup-footer">
                <v-spacer></v-spacer>
                <v-btn flat class="flight-popup-cancel-btn" @click.native="ticketdetay=false">
                    <v-icon left small>close</v-icon>
                    {{$t("cancel_button")}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import allLocales from '@fullcalendar/core/locales-all';
import auth from "@/api/auth.js"
import helpers from "@/components/app/customcomp/helpers.js"
import tool from "../coper/tools"
import tarihim from "@/components/app/customcomp/tarihim.vue"

export default {
    components: {
        tarihim,
        FullCalendar // make the <FullCalendar> tag available
    },
    data: function () {
        return {
            headercoperVizeCikis: [{
                    text: this.$t('Name-of-Customer'),
                    value: "MusteriAdi",
                    width: "15%",
                    align: "left"
                },
                {
                    text: this.$t('Name-of-Seller'),
                    value: "OtelAdi",
                    width: "10%",
                    align: "left"
                },
                {
                    text: this.$t('Type'),
                    value: "vizeTip",
                    width: "5%",
                    align: "left"
                },                {
                    text: 'PNR',
                    value: "PNR",
                    width: "8%",
                    align: "left"
                },

                {
                    text: this.$t('Details'),
                    value: "detay",
                    width: "5%",
                    align: "right"
                },
            ],
            headercoperVizeGiris: [{
                    text: this.$t('Name-of-Customer'),
                    value: "MusteriAdi",
                    width: "15%",
                    align: "left"
                },
                {
                    text: this.$t('Name-of-Seller'),
                    value: "OtelAdi",
                    width: "10%",
                    align: "left"
                },
                {
                    text: this.$t('Type'),
                    value: "vizeTip",
                    width: "5%",
                    align: "left"
                },                {
                    text: 'PNR',
                    value: "PNR",
                    width: "8%",
                    align: "left"
                },

                {
                    text: this.$t('Details'),
                    value: "detay",
                    width: "5%",
                    align: "right"
                },
            ],
            headercoperSigorta: [{
                    text: this.$t('Name-of-Customer'),
                    value: "MusteriAdi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Name-of-Seller'),
                    value: "OtelAdi",
                    width: "15%",
                    align: "left"
                },
                {
                    text: this.$t('Starting-Date'),
                    value: "basTarih",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Finishing-Date'),
                    value: "bitTarih",
                    width: "5%",
                    align: "left"
                },                {
                    text: 'PNR',
                    value: "PNR",
                    width: "8%",
                    align: "left"
                },

                {
                    text: this.$t('Details'),
                    value: "detay",
                    width: "5%",
                    align: "right"
                },
            ],
            headercoperGemi: [{
                    text: this.$t('Name-of-Customer'),
                    value: "MusteriAdi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Name-of-Seller'),
                    value: "OtelAdi",
                    width: "15%",
                    align: "left"
                },
                {
                    text: this.$t('Date'),
                    value: "basTarih",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Location'),
                    value: "konum",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Room-Type'),
                    value: "OdaTipi",
                    width: "5%",
                    align: "left"
                },                {
                    text: 'PNR',
                    value: "PNR",
                    width: "8%",
                    align: "left"
                },

                {
                    text: this.$t('Details'),
                    value: "detay",
                    width: "5%",
                    align: "right"
                },
            ],
            headercoperTur: [{
                    text: this.$t('Name-of-Customer'),
                    value: "MusteriAdi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Name-of-Seller'),
                    value: "SaticiAdi",
                    width: "20%",
                    align: "left"
                },
                {
                    text: this.$t('Date'),
                    value: "basTarih",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Hour'),
                    value: "saat",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Meeting-Place'),
                    value: "bulusmayeri",
                    width: "5%",
                    align: "left"
                },                {
                    text: 'PNR',
                    value: "PNR",
                    width: "8%",
                    align: "left"
                },

                {
                    text: this.$t('Details'),
                    value: "detay",
                    width: "5%",
                    align: "right"
                },
            ],
            headercoperRentGiris: [{
                    text: this.$t('Name-of-Customer'),
                    value: "MusteriAdi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Name-of-Seller'),
                    value: "SaticiAdi",
                    width: "20%",
                    align: "left"
                },
                {
                    text: this.$t('Date'),
                    value: "basTarih",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Delivery-Time'),
                    value: "teslimsaat",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Delivery-Place'),
                    value: "teslimyeri",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Vehicle-Type'),
                    value: "aractipi",
                    width: "5%",
                    align: "left"
                }, {
                    text: this.$t('Vehicle'),
                    value: "teslimsaat",
                    width: "5%",
                    align: "left"
                },                {
                    text: 'PNR',
                    value: "PNR",
                    width: "8%",
                    align: "left"
                },

                {
                    text: this.$t('Details'),
                    value: "detay",
                    width: "5%",
                    align: "right"
                },
            ],
            headercoperRentCikis: [{
                    text: this.$t('Name-of-Customer'),
                    value: "MusteriAdi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Name-of-Seller'),
                    value: "SaticiAdi",
                    width: "20%",
                    align: "left"
                },
                {
                    text: this.$t('Date'),
                    value: "basTarih",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Boarding-Time'),
                    value: "teslimsaat",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Boarding-Place'),
                    value: "teslimyeri",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Vehicle-Type'),
                    value: "aractipi",
                    width: "5%",
                    align: "left"
                }, {
                    text: this.$t('Vehicle'),
                    value: "teslimsaat",
                    width: "5%",
                    align: "left"
                },                {
                    text: 'PNR',
                    value: "PNR",
                    width: "8%",
                    align: "left"
                },

                {
                    text: this.$t('Details'),
                    value: "detay",
                    width: "5%",
                    align: "right"
                },
            ],
            headercoperDiger: [{
                    text: this.$t('Name-of-Customer'),
                    value: "MusteriAdi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Name-of-Seller'),
                    value: "SaticiAdi",
                    width: "20%",
                    align: "left"
                },
                {
                    text: this.$t('Date'),
                    value: "basTarih",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Acitivity'),
                    value: "aktivite",
                    width: "5%",
                    align: "left"
                },                {
                    text: 'PNR',
                    value: "PNR",
                    width: "8%",
                    align: "left"
                },

                {
                    text: this.$t('Details'),
                    value: "detay",
                    width: "5%",
                    align: "right"
                },
            ],
            headercoperCharter: [
  {
    text: this.$t('Name-of-Customer'),
    value: 'MusteriAdi',
    width: '15%',
    align: 'left'
  },
  {
    text: this.$t('Name-of-Seller'),
    value: 'SaticiAdi',
    width: '15%',
    align: 'left'
  },
  {
    text: this.$t('From-Where'),
    value: 'Nereden',
    width: '12%',
    align: 'left'
  },
  {
    text: this.$t('To-Where'),
    value: 'Nereye',
    width: '12%',
    align: 'left'
  },
  {
    text: this.$t('Flight-Time'),
    value: 'UcusSaati',
    width: '12%',
    align: 'left'
  },
  {
    text: this.$t('Flight-Date'),
    value: 'Tarih',
    width: '12%',
    align: 'left'
  },
  {
    text: this.$t('Option-Date'),
    value: 'OpsiyonTarihi',
    width: '12%',
    align: 'left'
  },
  {
    text: this.$t('Option-Time'),
    value: 'OpsiyonSaati',
    width: '12%',
    align: 'left'
  },  {
    text: 'PNR',
    value: 'PNR',
    width: '10%',
    align: 'left'
  },

  {
    text: this.$t('Details'),
    value: 'detay',
    width: '8%',
    align: 'right',
    sortable: false
  }
],
            headercoperAll: [{
                    text: this.$t('Name-of-Customer'),
                    value: "MusteriAdi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Name-of-Seller'),
                    value: "SaticiAdi",
                    width: "20%",
                    align: "left"
                },
                {
                    text: this.$t('Date'),
                    value: "basTarih",
                    width: "5%",
                    align: "left"
                },                {
                    text: 'PNR',
                    value: "PNR",
                    width: "8%",
                    align: "left"
                },

                {
                    text: this.$t('Details'),
                    value: "detay",
                    width: "5%",
                    align: "right"
                },
            ],
            headercoperArac: [{
                    text: this.$t('Name-of-Customer'),
                    value: "MusteriAdi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Name-of-Seller'),
                    value: "SaticiAdi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Date'),
                    value: "basTarih",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Vehicle-Type'),
                    value: "konum",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Boarding-Place'),
                    value: "OdaTipi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Departure-Place'),
                    value: "OdaTipi",
                    width: "5%",
                    align: "left"
                },                {
                    text: 'PNR',
                    value: "PNR",
                    width: "8%",
                    align: "left"
                },

                {
                    text: this.$t('Details'),
                    value: "detay",
                    width: "5%",
                    align: "right"
                },
            ],
            headercoperOtel: [{
                    text: this.$t('Name-of-Customer'),
                    value: "MusteriAdi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Hotel-Name'),
                    value: "OtelAdi",
                    width: "15%",
                    align: "left"
                },
                {
                    text: this.$t('Date'),
                    value: "basTarih",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Location'),
                    value: "konum",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Room-Type'),
                    value: "OdaTipi",
                    width: "5%",
                    align: "left"
                },                {
                    text: 'PNR',
                    value: "PNR",
                    width: "8%",
                    align: "left"
                },

                {
                    text: this.$t('Details'),
                    value: "detay",
                    width: "5%",
                    align: "right"
                },
            ],
            headerticket: [{
                    text: this.$t('Airline'),
                    value: "Havayolu",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Departure-Route'),
                    value: "KalkisParkur",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Arrival-Route'),
                    value: "VarisParkur",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Flight-Time'),
                    value: "UcusSaat",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Flight-Date'),
                    value: "UcusTarihi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Name-of-Passenger'),
                    value: "YolcuAdi",
                    width: "5%",
                    align: "left"
                },
                {
                    text: 'PNR',
                    value: "PnrNo",
                    width: "5%",
                    align: "left"
                },
                {
                    text: this.$t('Details'),
                    value: "Detay",
                    width: "5%",
                    align: "right"
                }
            ],
            CalendarInput: {
                StartDate: null,
                EndDate: null
            },
            calendarEvents: [],
            VizeRandevu: false,
            TurBulusma: false,
            validform: true,
            takvimekle: false,
            coperdetay: false,
            ticketdetay: false,
            text1: null,
            coperVizeCikisList: [],
            coperVizeGirisList: [],
            coperSigortaList: [],
            coperGemiList: [],
            ticketList: [],
            coperOtelList: [],
            coperAracList: [],
            coperCharterList: [],
            coperAllList: [],
            coperDigerList: [],
            coperRentCikisList: [],
            coperRentGirisList: [],
            coperTurList: [],
            coperVizeGiris: false,
            coperVizeCikis: false,
            coperSigorta: false,
            coperGemi: false,
            coperRentGiris: false,
            coperRentCikis: false,
            coperDiger: false,
            coperAll: false,
            coperCharter: false,
            coperArac: false,
            coperOtel: false,
            coperTur: false,
            detayTarih: null,
            calendarLocale:"en",
            calendarOptions: {
                plugins: [
                    dayGridPlugin,
                    timeGridPlugin,
                    interactionPlugin // needed for dateClick
                ],
                header: {
                    left: "prev,next today",
                    center: "title",
                    right: "dayGridMonth,timeGridWeek,timeGridDay,listWeek"
                },
                customButtons: {
                    today: { // this overrides the prev button
                        text: this.$t('Today'),
                        click: () => {
                            this.calendarEvents = []
                            this.calendarOptions.events = this.calendarEvents
                            var date = new Date();
                            var dd = String(date.getDate()).padStart(2, '0');
                            var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
                            var yyyy = date.getFullYear();
                            var mmend = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
                            var endyyyy = date.getFullYear();

                            if (mmend >= 12) {
                                mmend = (Number(mm) + 1) - 12;
                                endyyyy = Number(endyyyy) + 1;
                            } else {
                                mmend = Number(mmend) + 1
                            }
                      
                            if (Number(mmend) < 9) {
                                mmend = '0' + mmend
                            }
                            var start = yyyy + '-' + mm + '-' + 1
                            var end = endyyyy + '-' + mmend + '-' + 1

                            this.getEventsCoper(start, end)
                            this.getEventsTicket(start, end)

                            let calendarApi = this.$refs.fullCalendar.getApi();
                            calendarApi.gotoDate(date);

                        }
                    },
                    prev: { // this overrides the prev button
                        text: "PREV",
                        click: () => {
                            let calendarApi = this.$refs.fullCalendar.getApi();
                            calendarApi.prev();

                            var date = new Date(calendarApi.getDate());
                            var dd = String(date.getDate()).padStart(2, '0');
                            var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
                            var yyyy = date.getFullYear();
                            var mmend = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
                            var endyyyy = date.getFullYear();

                            if (mmend >= 12) {
                                mmend = (Number(mm) + 1) - 12;
                                endyyyy = Number(endyyyy) + 1;
                            } else {
                                mmend = Number(mmend) + 1
                            }
                       
                            if (Number(mmend) < 9) {
                                mmend = '0' + mmend
                            }
                            var start = yyyy + '-' + mm + '-' + 1
                            var end = endyyyy + '-' + mmend + '-' + 1

                            this.getEventsCoper(start, end)
                            this.getEventsTicket(start, end)

                        }
                    },
                    next: { // this overrides the next button
                        text: "PREV",
                        click: () => {
                            let calendarApi = this.$refs.fullCalendar.getApi();
                            calendarApi.next();

                            var date = new Date(calendarApi.getDate());
                            var dd = String(date.getDate()).padStart(2, '0');
                            var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
                            var yyyy = date.getFullYear();
                            var mmend = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
                            var endyyyy = date.getFullYear();

                            if (mmend >= 12) {
                                mmend = (Number(mm) + 1) - 12;
                                endyyyy = Number(endyyyy) + 1;
                            } else {
                                mmend = Number(mmend) + 1
                            }
                
                            if (Number(mmend) < 9) {
                                mmend = '0' + mmend
                            }
                            var start = yyyy + '-' + mm + '-' + 1
                            var end = endyyyy + '-' + mmend + '-' + 1

                            this.getEventsCoper(start, end)
                            this.getEventsTicket(start, end)

                        }
                    }
                },
                initialView: 'dayGridMonth',
                initialEvents: null, // alternatively, use the `events` setting to fetch from a feed
                //editable: true,
                //selectable: true,
                selectMirror: true,
                dayMaxEvents: true,
                weekends: true,
                select: this.handleDateSelect,
                eventClick: this.handleEventClick,
                eventsSet: this.handleEvents,
                locales: allLocales,
                locale: localStorage.getItem('lang'),
                events: null,
            },
            currentEvents: [],
            MusaitlikInput: {
                DoctorID: 0,
                RequestID: 0,
                StartDate: null,
                EndDate: null,
                Status: null,
            },
            selectedDate: null,
            AvailabilityID: null,
        }
    },
    beforeMount: beforeMount,

    methods: {
        logout() {
            auth.logout()
        },
        handleWeekendsToggle() {
            this.calendarOptions.weekends = !this.calendarOptions.weekends // update a property
        },
        handleDateSelect(selectInfo) {
            this.selectedDate = ""
            this.selectedDate = selectInfo.end
            this.takvimekle = true
        },
        handleEventClick(clickInfo) {
            if (clickInfo.event.extendedProps.Provider === "ticket") {
                this.ticketdetay = true

                var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                var params = {
                    CompanyCode: credentials.SirketKodu,
                    StartDate: clickInfo.event.extendedProps.Tarih,
                    EndDate: clickInfo.event.extendedProps.Tarih
                }

                this.$http.post(auth.API_URL + 'api/TicketReport/FlightCalenderList', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.ticketList = []
                    this.ticketList = response.body

                }, (response) => {
                    if (response.status === 0) {
                         this.text1 = this.$t(response.body.ResponseMessage)
                        this.snackbar = true
                    } else {
                        this.text1 = response.statusText
                        this.snackbar = true
                    }
                })

            } else if (clickInfo.event.extendedProps.Provider === "coper") {
                this.coperOtel = false
                this.coperArac = false
                this.coperDiger = false
                this.coperCharter = false
                this.coperAll = false
                this.VizeRandevu = false
                this.TurBulusma = false
                this.coperRentCikis = false
                this.coperRentGiris = false
                this.coperTur = false
                this.coperGemi = false
                this.coperSigorta = false
                this.coperVizeCikis = false
                this.coperVizeGiris = false
                this.coperVizeGirisList = []
                this.coperVizeCikisList = []
                this.coperSigortaList = []
                this.coperGemiList = []
                this.coperTurList = []
                this.coperRentGirisList = []
                this.coperRentCikisList = []
                this.coperDigerList = []
                this.coperCharterList = []
                this.coperAllList = []
                this.coperOtelList = []
                this.coperAracList = []
                this.coperdetay = true

                let params = {
                    "Tarih1": clickInfo.event.extendedProps.Tarih,
                    "Tarih2": clickInfo.event.extendedProps.Tarih,
                    "SaticiTip": {},
                    "SaticiTipInt": clickInfo.event.extendedProps.SalesType,
                    "Cikis": clickInfo.event.extendedProps.Cikis,
                    "VizeRandevu": clickInfo.event.extendedProps.VizeRandevu,
                    "TurBulusma": clickInfo.event.extendedProps.TurBulusma,
                }
                tool.http_post(this, 'NextCleanderCoper', params).then(
                    response => {
                        if (response.body.Status == true) {
                            for (var i = 0; i < response.body.data.length; i++) {
                                if (response.body.data[i].SaticiTip == 1) {
                                    this.coperOtel = true
                                    this.coperOtelList.push({
                                        MusteriAdi: response.body.data[i].KisiIsim,
                                        SaticiAdi: response.body.data[i].SaticiAd,
                                        Tarih: response.body.data[i].StartDate,
                                        Konum: response.body.data[i].Otel_Konum,
                                        OdaTipi: response.body.data[i].Otel_OdaTipi,
                                        PNR: response.body.data[i].PNR_No,
                                        TakipNo: this.getCoperTakipNo(response.body.data[i])
                                    })
                                } else if (response.body.data[i].SaticiTip == 2) {
                                    this.coperArac = true
                                    this.coperAracList.push({
                                        MusteriAdi: response.body.data[i].KisiIsim,
                                        SaticiAdi: response.body.data[i].SaticiAd,
                                        Tarih: response.body.data[i].StartDate,
                                        Nereden: response.body.data[i].Transfer_Nerden,
                                        Nereye: response.body.data[i].Transfer_Nereye,
                                        AracTip: response.body.data[i].Transfer_Arac,
                                        PNR: response.body.data[i].PNR_No,
                                        TakipNo: this.getCoperTakipNo(response.body.data[i])
                                    })
                                } else if (response.body.data[i].SaticiTip == 10) {
                                    this.coperDiger = true
                                    this.coperDigerList.push({
                                        MusteriAdi: response.body.data[i].KisiIsim,
                                        SaticiAdi: response.body.data[i].SaticiAd,
                                        Tarih: response.body.data[i].StartDate,
                                        Aktivite: response.body.data[i].Diger_Aktivite,
                                        PNR: response.body.data[i].PNR_No,
                                        TakipNo: this.getCoperTakipNo(response.body.data[i])
                                    })
                                } else if (response.body.data[i].SaticiTip == 4) {
                                    this.coperTur = true
                                    this.coperTurList.push({
                                        MusteriAdi: response.body.data[i].KisiIsim,
                                        SaticiAdi: response.body.data[i].SaticiAd,
                                        Tarih: response.body.data[i].Tur_BulusmaTarihi,
                                        Saat: response.body.data[i].Tur_BulusmaSaati.substring(11, 16),
                                        BulusmaYeri: response.body.data[i].Tur_BulusmaYeri,
                                        PNR: response.body.data[i].PNR_No,
                                        TakipNo: this.getCoperTakipNo(response.body.data[i])
                                    })
                                } else if (response.body.data[i].SaticiTip == 5) {
                                    if (clickInfo.event.extendedProps.Cikis) {
                                        this.coperRentCikis = true
                                        this.coperRentCikisList.push({
                                            MusteriAdi: response.body.data[i].KisiIsim,
                                            SaticiAdi: response.body.data[i].SaticiAd,
                                            Tarih: response.body.data[i].EndDate,
                                            TeslimYeri: response.body.data[i].RCR_TeslimYeri,
                                            TeslimSaati: response.body.data[i].RCR_TeslimSaat.substring(11, 16),
                                            AracTipi: response.body.data[i].RCR_Kategori,
                                            Arac: response.body.data[i].RCR_Arac,
                                            PNR: response.body.data[i].PNR_No,
                                        TakipNo: this.getCoperTakipNo(response.body.data[i])
                                        })
                                    } else {
                                        this.coperRentGiris = true
                                        this.coperRentGirisList.push({
                                            MusteriAdi: response.body.data[i].KisiIsim,
                                            SaticiAdi: response.body.data[i].SaticiAd,
                                            Tarih: response.body.data[i].StartDate,
                                            AlinisYeri: response.body.data[i].RCR_AlisYeri,
                                            AlinisSaati: response.body.data[i].RCR_AlisSaat.substring(11, 16),
                                            AracTipi: response.body.data[i].RCR_Kategori,
                                            Arac: response.body.data[i].RCR_Arac,
                                            PNR: response.body.data[i].PNR_No,
                                        TakipNo: this.getCoperTakipNo(response.body.data[i])
                                        })
                                    }
                                } else if (response.body.data[i].SaticiTip == 9) {
                                    this.coperGemi = true
                                    var Tarih = ""
                                    if (clickInfo.event.extendedProps.Cikis) {
                                        Tarih = response.body.data[i].EndDate
                                    } else {
                                        Tarih = response.body.data[i].StartDate
                                    }
                                    this.coperGemiList.push({
                                        MusteriAdi: response.body.data[i].KisiIsim,
                                        SaticiAdi: response.body.data[i].SaticiAd,
                                        Tarih: Tarih,
                                        Konum: response.body.data[i].Otel_Konum,
                                        OdaTipi: response.body.data[i].Otel_OdaTipi,
                                        PNR: response.body.data[i].PNR_No,
                                        TakipNo: this.getCoperTakipNo(response.body.data[i])
                                    })
                                } else if (response.body.data[i].SaticiTip == 14) {
                                    this.coperSigorta = true
                                    this.coperSigortaList.push({
                                        MusteriAdi: response.body.data[i].KisiIsim,
                                        SaticiAdi: response.body.data[i].SaticiAd,
                                        BasTarih: response.body.data[i].StartDate,
                                        BitTarih: response.body.data[i].EndDate,
                                        PNR: response.body.data[i].PNR_No,
                                        TakipNo: this.getCoperTakipNo(response.body.data[i])
                                    })
                                } else if (response.body.data[i].SaticiTip == 11) {
                                    if (clickInfo.event.extendedProps.Cikis) {
                                        this.coperVizeCikis = true
                                        this.coperVizeCikisList.push({
                                            MusteriAdi: response.body.data[i].KisiIsim,
                                            SaticiAdi: response.body.data[i].SaticiAd,
                                            Tarih: response.body.data[i].Vize_RandevuZamani,
                                            VizeTip: response.body.data[i].Vize_Tip,
                                            PNR: response.body.data[i].PNR_No,
                                        TakipNo: this.getCoperTakipNo(response.body.data[i])
                                        })
                                    } else {
                                        this.coperVizeGiris = true
                                        this.coperVizeGirisList.push({
                                            MusteriAdi: response.body.data[i].KisiIsim,
                                            SaticiAdi: response.body.data[i].SaticiAd,
                                            Tarih: response.body.data[i].Vize_RandevuZamani,
                                            TeslimYeri: response.body.data[i].Vize_Tip,
                                            PNR: response.body.data[i].PNR_No,
                                        TakipNo: this.getCoperTakipNo(response.body.data[i])
                                        })
                                    }
                                } else if (response.body.data[i].SaticiTip == 8) {
                                this.coperCharter = true

                                var charterUcusSaati =
                                response.body.data[i].Charter_UcusSaati

                                var charterOpsiyonluMusteri =
                                response.body.data[i].Charter_OpsiyonluMusteri === true

                                var charterOpsiyonSaati =
                                response.body.data[i].Charter_OpsiyonSaati

                                this.coperCharterList.push({
                                 MusteriAdi: response.body.data[i].KisiIsim,
                                 SaticiAdi: response.body.data[i].SaticiAd,
                                 Nereden: response.body.data[i].Charter_Nereden,
                                 Nereye: response.body.data[i].Charter_Nereye,
                                 UcusSaati: charterUcusSaati ? charterUcusSaati.substring(11, 16)  : '',
                                 OpsiyonluMusteri: charterOpsiyonluMusteri,
                                 OpsiyonTarihi: charterOpsiyonluMusteri ? response.body.data[i].Charter_OpsiyonTarihi : null,
                                 OpsiyonSaati: charterOpsiyonluMusteri && charterOpsiyonSaati ? charterOpsiyonSaati.substring(11, 16) : '',
      
     
                               Tarih: response.body.data[i].StartDate,
                               PNR: response.body.data[i].PNR_No,
                               TakipNo: this.getCoperTakipNo(response.body.data[i])
                                })
                                } else {
                                this.coperAll = true

                                this.coperAllList.push({
                                MusteriAdi: response.body.data[i].KisiIsim,
                                SaticiAdi: response.body.data[i].SaticiAd,
                                Tarih: response.body.data[i].StartDate,
                                PNR: response.body.data[i].PNR_No,
                                 TakipNo: this.getCoperTakipNo(response.body.data[i])
                                })
                                  }
                            }
                        } else {
                            this.text1 = response.body.ErrorList[0]
                            this.snackbar = true
                        }
                    },
                    response => {
                        this.text1 = 'Hata Oluştu, tekrar deneyiniz'
                        this.snackbar = true
                    }
                );

            }
        },
        handleEvents(events) {},
        getEventsCoper: getEventsCoper,
        getEventsTicket: getEventsTicket,
        getEventSearch: getEventSearch,
        git: git,
        gitcoper: gitcoper,
        getCoperTakipNo: getCoperTakipNo,
    },
    filters: {
        dateformat: function (t) {
            return helpers.dateformat(t);
        },
        timeformat: function (t) {
            return helpers.getTime(t)
        }
    }

}
function getAktifSimpleMode() {
    var manageload = null

    try {
        manageload = JSON.parse(window.localStorage.getItem('WebUserManageLoad'))
    } catch (e) {
        manageload = null
    }

    if (manageload && manageload.UserInfo) {
        return manageload.UserInfo.SimpleMode === true ||
            manageload.UserInfo.SimpleMode === 1 ||
            manageload.UserInfo.SimpleMode === '1' ||
            manageload.UserInfo.SimpleMode === 'true'
    }

    return false
}

function gitcoper(item) {
    item = item || {}

    var simpleMode = getAktifSimpleMode()

    var takipNo = getCoperTakipNo(item)

    var pnrNo =
        item.PNR ||
        item.PNR_No ||
        item.pNR_No ||
        item.pnr ||
        item.sourcePnr ||
        ''

    if (simpleMode) {
        if (!takipNo || takipNo == '0') {
            alert('Takip No bulunamadı. Simple Mode detay açmak için Takip No gerekli.')
            return
        }

        var simpleUrl =
            '#/coper/rezervasyon/newcoper?islem=get&TakipNo=' +
            encodeURIComponent(takipNo)

        window.open(simpleUrl, '_blank')
        return
    }

    var normalUrl =
        '#/coper/rezervasyon/index/id?islem=get&PNR_No=' +
        encodeURIComponent(pnrNo)

    window.open(normalUrl, '_blank')
}

function getCoperTakipNo(row) {
    row = row || {}

    return row.TakipNo ||
        row.takipNo ||
        row.Takip_No ||
        row.takip_No ||
        row.SatisGrubu ||
        row.satisGrubu ||
        row.SatisGrup ||
        row.satisGrup ||
        row.GrupNo ||
        row.grupNo ||
        row.MiceTakipNo ||
        row.miceTakipNo ||
        row.PNR_TakipNo ||
        row.pnrTakipNo ||
        row.PNR_No ||
        row.pNR_No ||
        row.PNR ||
        row.pnr ||
        ''
}

function git(item) {
    var simpleMode = getAktifSimpleMode()

    var status =
        item.Status ||
        item.status ||
        ''

    var isl = status == 'V'
        ? 'voidget'
        : 'get'

    var havayoluKodu =
        item.HavayoluKodu ||
        item.HavaYoluKodu ||
        item.HyoluKodu ||
        ''

    var biletNo =
        item.BiletNo ||
        item.biletNo ||
        ''

    var ucusTipi =
        item.UcusTipi ||
        item.UcusTip ||
        item.ucusTipi ||
        ''

    var baseUrl = simpleMode
        ? '#/bilet/newbilet2/id?'
        : '#/bilet/yeni/id?'

    var url = baseUrl
        + 'isl=' + encodeURIComponent(isl)
        + '&hyolukod=' + encodeURIComponent(havayoluKodu)
        + '&biletno=' + encodeURIComponent(biletNo)
        + '&ucustipi=' + encodeURIComponent(ucusTipi)

    window.open(url, '_blank')
}

function getEventSearch() {
    var startDate = this.CalendarInput.StartDate
    var endDate = this.CalendarInput.EndDate

    var GetDate = new Date(startDate);
    let calendarApi = this.$refs.fullCalendar.getApi();
    calendarApi.gotoDate(GetDate);

    this.getEventsCoper(startDate, endDate)
    this.getEventsTicket(startDate, endDate)

}

function getEventsCoper(startDate, endDate) {
    this.calendarEvents = []
    this.calendarOptions.events = this.calendarEvents
    let params = {
        "Tarih1": startDate,
        "Tarih2": endDate,
        "SaticiTip": {
            Otel: true,
            Arac: true,
            Restaurant: true,
            Acente: true,
            RentACar: true,
            Rehber: true,
            Muze: true,
            Charter: true,
            Gemi: true,
            Diger: true,
            Feribot: true,
            Golf: true,
            Vize: true

        },
        "CikisSaticiTip": {
            Otel: true,
            RentACar: true,
            Gemi: true,
            Vize: true,
            Sigorta: true
        }
    }
    tool.http_post(this, 'NextCalendarCount', params).then(
        response => {
            if (response.body.Status == true) {
                for (var i = 0; i < response.body.data.length; i++) {
                    var islemAd = ""
                    if (response.body.data[i].SaticiTip == 1) {
                        if (!response.body.data[i].Cikis) {
                            islemAd = this.$t('Hotel') + " Check In"
                        } else {
                            islemAd = this.$t('Hotel') + " Check Out"
                        }

                    } else if (response.body.data[i].SaticiTip == 2) {
                        if (!response.body.data[i].Cikis) {
                            islemAd = this.$t('Vehicle') + " Check In"
                        } else {
                            islemAd = this.$t('Vehicle') + " Check Out"
                        }
                    } else if (response.body.data[i].SaticiTip == 3) {
                        islemAd = "Restaurant"
                    } else if (response.body.data[i].SaticiTip == 4) {
                        islemAd = this.$t('Agency')
                    } else if (response.body.data[i].SaticiTip == 5) {
                        if (!response.body.data[i].Cikis) {
                            islemAd = "RentACar Check In"
                        } else {
                            islemAd = "RentACar Check Out"
                        }
                    } else if (response.body.data[i].SaticiTip == 6) {
                        islemAd = "Rehber"
                    } else if (response.body.data[i].SaticiTip == 7) {
                        if (!response.body.data[i].Cikis) {
                            islemAd =this.$t('Museum') + " Check In"
                        } else {
                            islemAd = this.$t('Museum') + " Check Out"
                        }
                    } else if (response.body.data[i].SaticiTip == 8) {
                        islemAd = "Charter"
                    } else if (response.body.data[i].SaticiTip == 9) {
                        if (!response.body.data[i].Cikis) {
                            islemAd =this.$t('Cruise') + " Check In"
                        } else {
                            islemAd = this.$t('Cruise') + " Check Out"
                        }
                    } else if (response.body.data[i].SaticiTip == 10) {
                        islemAd =this.$t('Other')
                    } else if (response.body.data[i].SaticiTip == 11) {
                        if (!response.body.data[i].VizeRandevu) {
                            if (!response.body.data[i].Cikis) {
                                islemAd = this.$t('Visa-Check-In')
                            } else {
                                islemAd = this.$t('Visa-Check-Out')
                            }
                        } else {
                            islemAd = this.$t('Visa-Appointment-Day')
                        }

                    } else if (response.body.data[i].SaticiTip == 12) {
                        islemAd = this.$t('Tour-Operator')
                    } else if (response.body.data[i].SaticiTip == 13) {
                        islemAd = this.$t('Consulate')
                    } else if (response.body.data[i].SaticiTip == 14) {
                        islemAd = this.$t('Insurance')
                    } else if (response.body.data[i].SaticiTip == 15) {
                        islemAd = this.$t('Ferry')
                    } else if (response.body.data[i].SaticiTip == 16) {
                        islemAd = "Golf"
                    }

                    this.calendarEvents.push({
                        title: response.body.data[i].Toplam + " " + islemAd,
                        start: response.body.data[i].Tarih,
                        end: response.body.data[i].Tarih,
                        color: 'purple',
                        Provider: 'coper',
                        SalesType: response.body.data[i].SaticiTip,
                        Tarih: response.body.data[i].Tarih,
                        Cikis: response.body.data[i].Cikis,
                        VizeRandevu: response.body.data[i].VizeRandevu,
                        TurBulusma: response.body.data[i].TurBulusma
                    })
                }
                this.calendarOptions.events = this.calendarEvents

            } else {
                this.text1 = response.body.ErrorList[0]
                this.snackbar = true
            }
        },
        response => {
            this.text1 = this.$t('An-error-has-occurred-Please-try-again')
            this.snackbar = true
        }
    );

}

function getEventsTicket(startDate, endDate) {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
        CompanyCode: credentials.SirketKodu,
        StartDate: startDate,
        EndDate: endDate
    }

    this.$http.post(auth.API_URL + 'api/TicketReport/FlightCountCalenderList', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {

        for (var i = 0; i < response.body.length; i++) {

            var title = response.body[i].UcusSayisi + this.$t('Number-Of-Flights')

            this.calendarEvents.push({
                title: title,
                start: response.body[i].UcusTarihi,
                end: response.body[i].UcusTarihi,
                color: 'green',
                Provider: 'ticket',
                Tarih: response.body[i].UcusTarihi
            })
        }
        this.calendarOptions.events = this.calendarEvents
    }, (response) => {
        if (response.status === 0) {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
}

function beforeMount() {

    this.calendarLocale= "en";
    console.log(this.calendarLocale);
    var date = new Date();
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getFullYear();
    var mmend = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var endyyyy = date.getFullYear();

    if (mmend >= 12) {
        mmend = (Number(mm) + 1) - 12;
        endyyyy = Number(endyyyy) + 1;
    } else {
        mmend = Number(mmend) + 1
    }
    if (Number(mmend) < 9) {
        mmend = '0' + mmend
    }
    var start = yyyy + '-' + mm + '-' + '01'
    var end = endyyyy + '-' + mmend + '-' + '01'

    this.getEventsCoper(start, end)
    this.getEventsTicket(start, end)

}
</script>

<style scoped>
h2 {
    margin: 0;
    font-size: 16px;
    color: darkgreen;

}

ul {
    margin: 0;
    padding: 0 0 0 1.5em;
    color: darkgreen;

}

li {
    margin: 1.5em 0;
    padding: 0;
    color: darkgreen;
}

b {
    /* used for event dates/times */
    margin-right: 3px;
    color: darkgreen;

}

.demo-app {
    min-height: calc(100vh - 64px);
    font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
    font-size: 14px;
    background: transparent;
}

.demo-app-main {
    flex-grow: 1;
    padding: 22px 22px 30px;
}

/* Modern Calendar Surface */
.calendar-page {
    min-height: 100vh;
    background:
        radial-gradient(circle at 12% 8%, rgba(33, 150, 243, 0.10), transparent 28%),
        radial-gradient(circle at 90% 22%, rgba(25, 118, 210, 0.08), transparent 26%),
        linear-gradient(180deg, #f6f9fd 0%, #eef3f8 100%);
    color: #26364a;
}

.calendar-top-card {
    background: transparent !important;
}

.calendar-page-toolbar {
    min-height: 64px !important;
    background: linear-gradient(120deg, #0b5fa5 0%, #1976d2 48%, #2997e6 100%) !important;
    box-shadow: 0 7px 24px rgba(13, 79, 139, 0.20) !important;
}

.calendar-page-toolbar >>> .v-toolbar__title {
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 0.15px;
}

.calendar-surface {
    margin: 0 22px 26px;
    padding: 22px !important;
    border: 1px solid rgba(214, 224, 236, 0.92);
    border-radius: 24px;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 18px 48px rgba(31, 55, 84, 0.10);
    backdrop-filter: blur(8px);
}

.demo-app-calendar >>> .fc {
    color: #26364a;
}

.demo-app-calendar >>> .fc .fc-toolbar {
    margin-bottom: 20px;
}

.demo-app-calendar >>> .fc .fc-toolbar-title {
    color: #1f2d3d;
    font-size: 24px;
    font-weight: 800;
    letter-spacing: -0.35px;
}

.demo-app-calendar >>> .fc .fc-button-primary {
    min-height: 38px;
    padding: 0 14px;
    border: 0 !important;
    border-radius: 10px !important;
    background: #34485e !important;
    box-shadow: 0 4px 12px rgba(38, 55, 73, 0.14);
    font-weight: 600;
    transition: all 0.18s ease;
}

.demo-app-calendar >>> .fc .fc-button-primary:hover {
    background: #1976d2 !important;
    transform: translateY(-1px);
    box-shadow: 0 7px 16px rgba(25, 118, 210, 0.22);
}

.demo-app-calendar >>> .fc .fc-button-primary:focus {
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.12) !important;
}

.demo-app-calendar >>> .fc .fc-today-button {
    background: #6f7d8c !important;
}

.demo-app-calendar >>> .fc-theme-standard .fc-scrollgrid {
    overflow: hidden;
    border: 1px solid #dfe7ef;
    border-radius: 14px;
    background: #ffffff;
}

.demo-app-calendar >>> .fc-theme-standard td,
.demo-app-calendar >>> .fc-theme-standard th {
    border-color: #e6edf4;
}

.demo-app-calendar >>> .fc .fc-col-header-cell {
    background: #f6f9fc;
}

.demo-app-calendar >>> .fc .fc-col-header-cell-cushion {
    padding: 10px 6px;
    color: #1976d2;
    font-size: 13px;
    font-weight: 800;
    text-decoration: none;
}

.demo-app-calendar >>> .fc .fc-daygrid-day {
    background: #ffffff;
    transition: background-color 0.16s ease;
}

.demo-app-calendar >>> .fc .fc-daygrid-day:hover {
    background: #f8fbff;
}

.demo-app-calendar >>> .fc .fc-day-today {
    background: linear-gradient(135deg, #fff9dc 0%, #fffdf2 100%) !important;
    box-shadow: inset 0 0 0 1px rgba(244, 193, 44, 0.24);
}

.demo-app-calendar >>> .fc .fc-daygrid-day-number {
    padding: 8px 8px 4px;
    color: #1976d2;
    font-size: 13px;
    font-weight: 700;
    text-decoration: none;
}

.demo-app-calendar >>> .fc .fc-daygrid-event {
    margin: 3px 5px;
    border: 0;
    border-radius: 9px;
    background: transparent;
}

.demo-app-calendar >>> .fc .fc-daygrid-event:hover {
    transform: translateY(-1px);
}

.demo-app-calendar >>> .fc-event .green,
.demo-app-calendar >>> .fc-event .purple {
    display: inline-flex;
    align-items: center;
    min-height: 24px;
    padding: 4px 7px !important;
    border-radius: 7px;
    font-weight: 700;
    box-shadow: 0 3px 8px rgba(30, 48, 66, 0.10);
}

.demo-app-calendar >>> .fc-event .v-icon {
    font-size: 20px;
}


/* Modern Flight List Popup */
.flight-popup-card {
    display: flex;
    flex-direction: column;
    border-radius: 22px;
    overflow: hidden;
    background: #ffffff;
    box-shadow: 0 28px 80px rgba(20, 39, 74, 0.24);
}

.flight-popup-header {
    display: flex;
    align-items: center;
    min-height: 68px;
    padding: 12px 18px;
    background: linear-gradient(135deg, #0f4c81 0%, #1976d2 55%, #42a5f5 100%);
    color: #ffffff;
    position: relative;
}

.flight-popup-header::after {
    content: '';
    position: absolute;
    width: 180px;
    height: 180px;
    right: -70px;
    top: -95px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.10);
}

.flight-popup-header-icon {
    width: 42px;
    height: 42px;
    min-width: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    border-radius: 13px;
    background: rgba(255, 255, 255, 0.17);
    border: 1px solid rgba(255, 255, 255, 0.22);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.18);
}

.flight-popup-heading {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.flight-popup-title {
    font-size: 22px;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: 0.2px;
}

.flight-popup-subtitle {
    margin-top: 4px;
}

.flight-popup-count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 28px;
    height: 22px;
    padding: 0 9px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.18);
    border: 1px solid rgba(255, 255, 255, 0.20);
    font-size: 12px;
    font-weight: 700;
}

.flight-popup-close {
    z-index: 2;
    background: rgba(255, 255, 255, 0.10);
    transition: all 0.2s ease;
}

.flight-popup-close:hover {
    background: rgba(255, 255, 255, 0.22);
    transform: rotate(4deg);
}

.flight-popup-body {
    padding: 12px 14px !important;
    background: #f6f8fb;
}

.flight-table-shell {
    overflow: hidden;
    border-radius: 16px;
    background: #ffffff;
    border: 1px solid #e6ebf2;
    box-shadow: 0 8px 24px rgba(31, 50, 81, 0.08);
}

.modern-flight-table {
    background: transparent;
}

.modern-flight-table >>> table.v-table {
    background: transparent;
}

.modern-flight-table >>> table.v-table thead tr {
    background: #f8fafc;
}

.modern-flight-table >>> table.v-table thead th {
    height: 34px;
    color: #5b6678;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.45px;
    text-transform: uppercase;
    border-bottom: 1px solid #e8edf3 !important;
}

.modern-flight-table >>> table.v-table tbody td {
    height: 42px;
    color: #28364a;
    font-size: 13px;
    border-bottom: 1px solid #eef2f6 !important;
}

.modern-flight-table >>> table.v-table tbody tr:last-child td {
    border-bottom: none !important;
}

.flight-table-row {
    transition: background-color 0.18s ease, box-shadow 0.18s ease;
}

.flight-table-row:hover {
    background: #f7fbff !important;
    box-shadow: inset 3px 0 0 #1976d2;
}

.airline-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 42px;
    height: 30px;
    padding: 0 10px;
    border-radius: 9px;
    background: #eaf4ff;
    color: #1565c0;
    font-weight: 800;
    letter-spacing: 0.5px;
}

.route-code {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 44px;
    height: 28px;
    padding: 0 9px;
    border-radius: 8px;
    background: #f2f5f8;
    color: #34495e;
    font-weight: 700;
    letter-spacing: 0.35px;
}

.flight-time-cell {
    font-weight: 700;
    color: #1f4e79 !important;
}

.flight-date-cell {
    white-space: nowrap;
    color: #56657a !important;
}

.passenger-cell {
    font-weight: 600;
}

.pnr-badge {
    display: inline-flex;
    align-items: center;
    min-height: 26px;
    padding: 3px 9px;
    border-radius: 9px;
    background: #edf7f1;
    color: #137547;
    border: 1px solid #d6ecdf;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.45px;
}

.flight-detail-btn {
    color: #1976d2 !important;
    background: #eef6ff;
    transition: all 0.18s ease;
}

.flight-detail-btn:hover {
    color: #ffffff !important;
    background: #1976d2;
    transform: translateY(-1px);
    box-shadow: 0 6px 14px rgba(25, 118, 210, 0.22);
}

.flight-detail-btn:hover >>> .v-icon {
    color: #ffffff !important;
}

.flight-popup-footer {
    min-height: 48px;
    padding: 6px 14px !important;
    background: #ffffff;
    border-top: 1px solid #e9edf2;
}

.flight-popup-cancel-btn {
    min-width: 110px;
    height: 38px;
    border-radius: 10px;
    color: #44536a !important;
    background: #f3f5f8;
    font-weight: 600;
    text-transform: none;
}

.flight-popup-cancel-btn:hover {
    background: #e9edf3;
}

.modern-flight-table >>> .v-datatable__actions {
    min-height: 44px;
    padding: 0 12px;
    color: #65748a;
    background: #fbfcfe;
    border-top: 1px solid #edf1f5;
}

.modern-flight-table >>> .v-table__overflow {
    overflow-x: auto;
    overflow-y: hidden;
}

.modern-flight-table >>> table.v-table {
    table-layout: auto;
}

.modern-flight-table >>> .v-datatable__actions__select {
    margin-right: 10px;
}

.modern-flight-table >>> .v-datatable__actions__pagination {
    margin: 0 8px;
}

@media (max-width: 960px) {
    .demo-app-main {
        padding: 12px;
    }

    .calendar-surface {
        margin: 0 10px 14px;
        padding: 12px !important;
        border-radius: 16px;
    }

    .demo-app-calendar >>> .fc .fc-toolbar-title {
        font-size: 18px;
    }

    .flight-popup-card {
        border-radius: 14px;
    }

    .flight-popup-header {
        min-height: 76px;
        padding: 14px 16px;
    }

    .flight-popup-header-icon {
        width: 44px;
        height: 44px;
        min-width: 44px;
        border-radius: 13px;
    }

    .flight-popup-title {
        font-size: 18px;
    }

    .flight-popup-body {
        padding: 12px !important;
    }

    .flight-table-shell {
        overflow-x: auto;
        border-radius: 12px;
    }

    .modern-flight-table {
        min-width: 920px;
    }
}


/* Premium Calendar Header */
.calendar-brand {
    display: flex;
    align-items: center;
    min-width: 0;
}

.calendar-brand-icon {
    width: 42px;
    height: 42px;
    min-width: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 13px;
    border-radius: 13px;
    background: rgba(255, 255, 255, 0.13);
    border: 1px solid rgba(255, 255, 255, 0.18);
    box-shadow:
        inset 0 1px 0 rgba(255, 255, 255, 0.18),
        0 8px 22px rgba(0, 0, 0, 0.14);
    backdrop-filter: blur(8px);
}

.calendar-brand-title {
    color: #ffffff;
    font-size: 20px;
    font-weight: 800;
    line-height: 1.2;
    letter-spacing: 0.15px;
}

.calendar-brand-accent {
    width: 34px;
    height: 3px;
    margin-top: 6px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.72);
}

.calendar-toolbar-mark {
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.11);
    border: 1px solid rgba(255, 255, 255, 0.16);
}

/* Premium Coper Popup */
.coper-popup-card {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-radius: 24px;
    background: #ffffff;
    box-shadow: 0 30px 90px rgba(15, 31, 54, 0.28);
}

.coper-popup-header {
    position: relative;
    display: flex;
    align-items: center;
    min-height: 72px;
    padding: 13px 20px;
    overflow: hidden;
    color: #ffffff;
    background:
        radial-gradient(circle at 88% -60%, rgba(255, 255, 255, 0.24), transparent 36%),
        linear-gradient(118deg, #10283f 0%, #164f7b 45%, #1976d2 100%);
}

.coper-popup-header::before {
    content: '';
    position: absolute;
    width: 230px;
    height: 230px;
    right: -105px;
    top: -150px;
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.10);
}

.coper-popup-header-icon {
    position: relative;
    z-index: 1;
    width: 44px;
    height: 44px;
    min-width: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 13px;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.14);
    border: 1px solid rgba(255, 255, 255, 0.18);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.16);
}

.coper-popup-heading {
    position: relative;
    z-index: 1;
}

.coper-popup-title {
    font-size: 21px;
    font-weight: 800;
    line-height: 1.2;
    letter-spacing: 0.15px;
}

.coper-popup-header-line {
    width: 42px;
    height: 3px;
    margin-top: 7px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.72);
}

.coper-popup-close {
    z-index: 2;
    margin-right: 0 !important;
    background: rgba(255, 255, 255, 0.10);
    border: 1px solid rgba(255, 255, 255, 0.12);
    transition: transform 0.18s ease, background-color 0.18s ease;
}

.coper-popup-close:hover {
    background: rgba(255, 255, 255, 0.20);
    transform: rotate(4deg);
}

.coper-popup-body {
    padding: 14px !important;
    background: linear-gradient(180deg, #f7f9fc 0%, #f3f6fa 100%);
}

.coper-popup-footer {
    min-height: 52px;
    padding: 7px 14px !important;
    background: #ffffff;
    border-top: 1px solid #e8edf3;
}

.coper-popup-cancel-btn {
    min-width: 112px;
    height: 38px;
    padding: 0 15px !important;
    border-radius: 11px;
    color: #40536a !important;
    background: #f1f4f8;
    font-weight: 700;
    text-transform: none;
    transition: all 0.18s ease;
}

.coper-popup-cancel-btn:hover {
    background: #e8edf4;
    transform: translateY(-1px);
}

/* Elite calendar surface overrides */
.calendar-page {
    background:
        radial-gradient(circle at 8% 4%, rgba(43, 139, 229, 0.14), transparent 26%),
        radial-gradient(circle at 92% 10%, rgba(64, 196, 255, 0.11), transparent 28%),
        radial-gradient(circle at 70% 92%, rgba(25, 118, 210, 0.07), transparent 34%),
        linear-gradient(145deg, #eef4fb 0%, #f8fafc 44%, #edf3f8 100%);
}

.calendar-page-toolbar {
    min-height: 68px !important;
    padding: 0 20px !important;
    background:
        radial-gradient(circle at 82% -120%, rgba(255, 255, 255, 0.19), transparent 38%),
        linear-gradient(115deg, #10283f 0%, #164f7b 46%, #1976d2 100%) !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 10px 30px rgba(16, 40, 63, 0.20) !important;
}

.calendar-surface {
    position: relative;
    margin: 20px 22px 28px;
    padding: 20px !important;
    overflow: hidden;
    border: 1px solid rgba(210, 221, 233, 0.88);
    border-radius: 26px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.99), rgba(250, 252, 254, 0.98));
    box-shadow:
        0 22px 60px rgba(27, 48, 74, 0.11),
        0 2px 8px rgba(27, 48, 74, 0.04);
}

.calendar-surface::before {
    content: '';
    position: absolute;
    width: 360px;
    height: 360px;
    right: -230px;
    top: -250px;
    border-radius: 50%;
    background: rgba(25, 118, 210, 0.045);
    pointer-events: none;
}

.demo-app-calendar >>> .fc .fc-toolbar {
    position: relative;
    z-index: 1;
    margin-bottom: 18px;
    padding: 2px 2px 10px;
}

.demo-app-calendar >>> .fc .fc-toolbar-title {
    color: #17324d;
    font-size: 25px;
    font-weight: 900;
    letter-spacing: -0.5px;
}

.demo-app-calendar >>> .fc .fc-button-primary {
    min-height: 38px;
    border-radius: 11px !important;
    background: #20384f !important;
    box-shadow: 0 5px 14px rgba(31, 53, 75, 0.16);
}

.demo-app-calendar >>> .fc .fc-button-primary:hover {
    background: #1976d2 !important;
    box-shadow: 0 8px 18px rgba(25, 118, 210, 0.25);
}

.demo-app-calendar >>> .fc .fc-today-button {
    background: #6e7e8f !important;
}

.demo-app-calendar >>> .fc-theme-standard .fc-scrollgrid {
    border: 1px solid #dce5ee;
    border-radius: 18px;
    box-shadow: 0 7px 22px rgba(31, 50, 77, 0.045);
}

.demo-app-calendar >>> .fc .fc-col-header-cell {
    background: linear-gradient(180deg, #f8fafc 0%, #f3f7fb 100%);
}

.demo-app-calendar >>> .fc .fc-col-header-cell-cushion {
    padding: 10px 6px;
    color: #1565c0;
    font-size: 12px;
    font-weight: 900;
    letter-spacing: 0.4px;
    text-transform: uppercase;
}

.demo-app-calendar >>> .fc .fc-daygrid-day {
    background: rgba(255, 255, 255, 0.98);
}

.demo-app-calendar >>> .fc .fc-daygrid-day:hover {
    background: #f5f9fd;
    box-shadow: inset 0 0 0 1px rgba(25, 118, 210, 0.06);
}

.demo-app-calendar >>> .fc .fc-day-today {
    background: linear-gradient(145deg, #fff9df 0%, #fffdf5 100%) !important;
    box-shadow: inset 0 0 0 1px rgba(230, 180, 42, 0.22);
}

.demo-app-calendar >>> .fc .fc-daygrid-day-number {
    padding: 8px 9px 4px;
    color: #1565c0;
    font-size: 12px;
    font-weight: 800;
}

.demo-app-calendar >>> .fc .fc-daygrid-event {
    margin: 3px 6px;
}

.demo-app-calendar >>> .fc-event .green,
.demo-app-calendar >>> .fc-event .purple {
    min-height: 25px;
    padding: 4px 9px !important;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 800;
    box-shadow: 0 4px 10px rgba(28, 48, 67, 0.12);
    transition: transform 0.16s ease, box-shadow 0.16s ease;
}

.demo-app-calendar >>> .fc-event:hover .green,
.demo-app-calendar >>> .fc-event:hover .purple {
    transform: translateY(-1px);
    box-shadow: 0 7px 15px rgba(28, 48, 67, 0.16);
}

</style>

<style>
.modern-flight-dialog {
    margin: 12px !important;
    max-height: calc(100vh - 24px) !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
}

@media (max-height: 760px) {
    .modern-flight-dialog {
        margin: 8px !important;
        max-height: calc(100vh - 16px) !important;
    }
}

/* Premium dialogs are intentionally unscoped because Vuetify mounts dialog content outside the component root. */
.modern-coper-dialog {
    width: calc(100vw - 34px) !important;
    max-width: 1240px !important;
    margin: 12px !important;
    overflow: visible !important;
    border-radius: 24px !important;
    box-shadow: none !important;
}

.modern-coper-dialog .v-card {
    border-radius: 24px !important;
}

.modern-coper-dialog .coper-popup-body {
    overflow: visible !important;
}

.modern-coper-dialog .modern-coper-table {
    overflow: hidden;
    border: 1px solid #e3e9f0;
    border-radius: 16px;
    background: #ffffff !important;
    box-shadow: 0 8px 24px rgba(29, 48, 73, 0.065);
}

.modern-coper-dialog .modern-coper-table .v-table__overflow {
    overflow-x: auto;
    overflow-y: hidden;
    border-radius: 16px 16px 0 0;
}

.modern-coper-dialog .modern-coper-table table.v-table {
    width: 100%;
    background: transparent !important;
}

.modern-coper-dialog .modern-coper-table table.v-table thead tr {
    background: linear-gradient(180deg, #f9fbfd 0%, #f4f7fa 100%);
}

.modern-coper-dialog .modern-coper-table table.v-table thead th {
    height: 36px !important;
    padding: 0 12px !important;
    color: #607086 !important;
    font-size: 10.5px !important;
    font-weight: 800 !important;
    letter-spacing: 0.38px;
    text-transform: uppercase;
    white-space: nowrap;
    border-bottom: 1px solid #e3e9ef !important;
}

.modern-coper-dialog .modern-coper-table table.v-table tbody td {
    height: 42px !important;
    padding: 0 12px !important;
    color: #27384b;
    font-size: 12.5px;
    white-space: nowrap;
    border-bottom: 1px solid #edf1f5 !important;
}

.modern-coper-dialog .modern-coper-table table.v-table tbody td:first-child {
    color: #152e48;
    font-weight: 800;
}

.modern-coper-dialog .modern-coper-table table.v-table tbody tr {
    background: #ffffff;
    transition: background-color 0.16s ease, box-shadow 0.16s ease;
}

.modern-coper-dialog .modern-coper-table table.v-table tbody tr:hover {
    background: #f5f9fd !important;
    box-shadow: inset 3px 0 0 #1976d2;
}

.modern-coper-dialog .modern-coper-table table.v-table tbody tr:last-child td {
    border-bottom: none !important;
}

.modern-coper-dialog .modern-coper-table .v-btn--icon {
    width: 32px !important;
    height: 32px !important;
    margin: 0 !important;
    border-radius: 10px !important;
    color: #1976d2 !important;
    background: #edf6ff !important;
    transition: all 0.17s ease;
}

.modern-coper-dialog .modern-coper-table .v-btn--icon:hover {
    color: #ffffff !important;
    background: #1976d2 !important;
    transform: translateY(-1px);
    box-shadow: 0 6px 14px rgba(25, 118, 210, 0.22);
}

.modern-coper-dialog .modern-coper-table .v-btn--icon:hover .v-icon {
    color: #ffffff !important;
}

.modern-coper-dialog .modern-coper-table .v-datatable__actions {
    min-height: 44px !important;
    padding: 0 12px !important;
    color: #697a8f;
    background: #fafbfd;
    border-top: 1px solid #e9eef3;
}

.modern-coper-dialog .modern-coper-table .v-datatable__actions__select {
    margin-right: 10px !important;
}

.modern-coper-dialog .modern-coper-table .v-datatable__actions__pagination {
    margin: 0 8px !important;
}

.modern-coper-dialog .modern-coper-table .v-datatable__actions .v-btn--icon {
    background: transparent !important;
    box-shadow: none !important;
}

.modern-coper-dialog .modern-coper-table .v-datatable__actions .v-btn--icon:hover {
    color: #1976d2 !important;
    background: #eef5fc !important;
    transform: none;
}

/* Both dialogs stay compact: pagination handles extra records instead of vertical dialog scrolling. */
.modern-flight-dialog {
    width: calc(100vw - 34px) !important;
    max-width: 1180px !important;
    margin: 12px !important;
    max-height: calc(100vh - 24px) !important;
    overflow: visible !important;
    border-radius: 22px !important;
}

.modern-flight-dialog .flight-popup-body {
    overflow: visible !important;
}

.modern-flight-dialog .modern-flight-table table.v-table thead th {
    height: 34px !important;
}

.modern-flight-dialog .modern-flight-table table.v-table tbody td {
    height: 40px !important;
}

@media (max-height: 680px) {
    .modern-coper-dialog,
    .modern-flight-dialog {
        margin: 7px !important;
    }

    .modern-coper-dialog .coper-popup-header,
    .modern-flight-dialog .flight-popup-header {
        min-height: 62px !important;
        padding-top: 9px !important;
        padding-bottom: 9px !important;
    }

    .modern-coper-dialog .coper-popup-body,
    .modern-flight-dialog .flight-popup-body {
        padding: 9px !important;
    }

    .modern-coper-dialog .modern-coper-table table.v-table tbody td,
    .modern-flight-dialog .modern-flight-table table.v-table tbody td {
        height: 37px !important;
    }

    .modern-coper-dialog .modern-coper-table .v-datatable__actions,
    .modern-flight-dialog .modern-flight-table .v-datatable__actions {
        min-height: 40px !important;
    }
}

@media (max-width: 960px) {
    .modern-coper-dialog {
        width: calc(100vw - 16px) !important;
        margin: 8px !important;
        border-radius: 16px !important;
    }

    .modern-coper-dialog .v-card {
        border-radius: 16px !important;
    }

    .modern-coper-dialog .coper-popup-header {
        min-height: 64px;
        padding: 10px 13px;
    }

    .modern-coper-dialog .coper-popup-title {
        font-size: 18px;
    }

    .modern-coper-dialog .coper-popup-body {
        padding: 8px !important;
    }

    .modern-coper-dialog .modern-coper-table .v-table__overflow {
        overflow-x: auto;
    }
}


/* Coper PNR */
.coper-pnr-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 72px;
    min-height: 26px;
    padding: 4px 10px;
    border: 1px solid rgba(25, 118, 210, 0.15);
    border-radius: 9px;
    color: #0f5ea8;
    background: linear-gradient(180deg, #f3f9ff 0%, #e9f4ff 100%);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.85);
    font-size: 11.5px;
    font-weight: 800;
    letter-spacing: 0.35px;
    white-space: nowrap;
}

/* Coper/Flight dialogs use the same premium visual language */
.modern-coper-dialog .coper-table-row:hover .coper-pnr-badge {
    color: #ffffff;
    border-color: #1976d2;
    background: #1976d2;
    box-shadow: 0 5px 12px rgba(25, 118, 210, 0.18);
}

.flight-popup-header {
    background:
        radial-gradient(circle at 88% -60%, rgba(255, 255, 255, 0.24), transparent 36%),
        linear-gradient(118deg, #10283f 0%, #164f7b 45%, #1976d2 100%) !important;
}

.flight-popup-header-line {
    width: 42px;
    height: 3px;
    margin-top: 7px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.72);
}

.flight-popup-card {
    border-radius: 24px !important;
    box-shadow: 0 30px 90px rgba(15, 31, 54, 0.28) !important;
}

.flight-popup-body {
    background: linear-gradient(180deg, #f7f9fc 0%, #f3f6fa 100%) !important;
}

.flight-popup-footer {
    border-top: 1px solid #e8edf3 !important;
    background: #ffffff !important;
}

.modern-flight-dialog .modern-flight-table {
    border: 1px solid #e3e9f0 !important;
    border-radius: 16px !important;
    background: #ffffff !important;
    box-shadow: 0 8px 24px rgba(29, 48, 73, 0.065) !important;
}

.modern-flight-dialog .modern-flight-table table.v-table thead tr {
    background: linear-gradient(180deg, #f9fbfd 0%, #f4f7fa 100%) !important;
}

.modern-flight-dialog .modern-flight-table table.v-table thead th {
    color: #607086 !important;
    font-size: 10.5px !important;
    font-weight: 800 !important;
    letter-spacing: 0.38px !important;
    text-transform: uppercase;
    border-bottom: 1px solid #e3e9ef !important;
}

.modern-flight-dialog .modern-flight-table table.v-table tbody td {
    color: #27384b !important;
    border-bottom: 1px solid #edf1f5 !important;
}

.modern-flight-dialog .modern-flight-table table.v-table tbody tr:hover {
    background: #f5f9fd !important;
    box-shadow: inset 3px 0 0 #1976d2;
}

.modern-flight-dialog .pnr-badge {
    min-width: 72px;
    border-radius: 9px !important;
    color: #0f5ea8 !important;
    background: linear-gradient(180deg, #f3f9ff 0%, #e9f4ff 100%) !important;
    border: 1px solid rgba(25, 118, 210, 0.15) !important;
}

.modern-flight-dialog .flight-table-row:hover .pnr-badge {
    color: #ffffff !important;
    background: #1976d2 !important;
    border-color: #1976d2 !important;
}

.modern-flight-dialog .flight-detail-btn,
.modern-coper-dialog .modern-coper-table .v-btn--icon {
    border-radius: 10px !important;
}

@media (max-height: 760px) {
    .modern-coper-dialog .coper-popup-header,
    .modern-flight-dialog .flight-popup-header {
        min-height: 58px !important;
        padding-top: 8px !important;
        padding-bottom: 8px !important;
    }

    .modern-coper-dialog .coper-popup-body,
    .modern-flight-dialog .flight-popup-body {
        padding: 8px !important;
    }

    .modern-coper-dialog .modern-coper-table table.v-table thead th,
    .modern-flight-dialog .modern-flight-table table.v-table thead th {
        height: 32px !important;
    }

    .modern-coper-dialog .modern-coper-table table.v-table tbody td,
    .modern-flight-dialog .modern-flight-table table.v-table tbody td {
        height: 36px !important;
    }

    .coper-pnr-badge,
    .modern-flight-dialog .pnr-badge {
        min-height: 24px;
        padding-top: 3px;
        padding-bottom: 3px;
    }
}



/* =========================================================
   POPUP DİKEY SCROLL - ÇOK FAZLA KAYIT İÇİN
   ========================================================= */

.modern-coper-dialog,
.modern-flight-dialog {
    max-height: calc(100vh - 24px) !important;
    overflow: hidden !important;
}

/* Popup kartı ekran yüksekliğini aşmasın */
.modern-coper-dialog .coper-popup-card,
.modern-flight-dialog .flight-popup-card {
    display: flex !important;
    flex-direction: column !important;
    max-height: calc(100vh - 24px) !important;
    overflow: hidden !important;
}

/* Başlık sabit kalsın */
.modern-coper-dialog .coper-popup-header,
.modern-flight-dialog .flight-popup-header {
    flex: 0 0 auto !important;
}

/* Kayıtların olduğu orta alan aşağı-yukarı kayabilsin */
.modern-coper-dialog .coper-popup-body,
.modern-flight-dialog .flight-popup-body {
    flex: 1 1 auto !important;
    min-height: 0 !important;
    max-height: calc(100vh - 155px) !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    overscroll-behavior: contain;
    scrollbar-width: thin;
}

/* Alt butonlar sabit kalsın */
.modern-coper-dialog .coper-popup-footer,
.modern-flight-dialog .flight-popup-footer {
    flex: 0 0 auto !important;
}

/* Chrome / Edge scrollbar görünümü */
.modern-coper-dialog .coper-popup-body::-webkit-scrollbar,
.modern-flight-dialog .flight-popup-body::-webkit-scrollbar {
    width: 8px;
}

.modern-coper-dialog .coper-popup-body::-webkit-scrollbar-track,
.modern-flight-dialog .flight-popup-body::-webkit-scrollbar-track {
    background: #f1f4f8;
    border-radius: 10px;
}

.modern-coper-dialog .coper-popup-body::-webkit-scrollbar-thumb,
.modern-flight-dialog .flight-popup-body::-webkit-scrollbar-thumb {
    background: #b8c5d3;
    border-radius: 10px;
}

.modern-coper-dialog .coper-popup-body::-webkit-scrollbar-thumb:hover,
.modern-flight-dialog .flight-popup-body::-webkit-scrollbar-thumb:hover {
    background: #8ea1b5;
}
</style>
